export class ControleDocaConfiguracao {
    constructor(
        
        public file_to_upload = null,
        
        private created_at = new Date(),
        private updated_at = new Date(),
    ) {
    }
}